export const allFilterValue = 'all'

export const ASSESSMENT_TYPES = {
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL',
}

export const CLASS_COUNT_1000_TOOLTIP_TEXT =
  'Your filters return over 1000 classes. Please add more specific ones (like Grade, Class) to narrow down the results.'

export const TEST_GRADE = 'Test Grade'
export const TEST_SUBJECT = 'Test Subject'
export const TEST_YEAR = 'Test Year'
export const CLASS_GRADE = 'Class Grade'
export const CLASS_SUBJECT = 'Class Subject'
export const CLASS_YEAR = 'Class Year'
export const SCHOOL_YEAR = 'School Year'

export const FilterTooltips = {
  [SCHOOL_YEAR]:
    'Filters students and tests by the selected school year. E.g.: Select 2024–25 to view all students and tests from that year.',
  [TEST_GRADE]:
    'Filter tests based on the grade level associated with the test. E.g.: View all Grade 6 test results, even if taken by students of Class Grade 7.',
  [TEST_SUBJECT]:
    'Filter tests by the subject associated with the test. E.g.: View all Math test results taken by students of any class.',
  [TEST_YEAR]:
    'Filter all tests conducted in the selected year(s). E.g.: Select 2024-25 to see the results of tests taken in that year.',
  [CLASS_GRADE]:
    'Filter students based on the grade level associated with their classes. Note: Classes can be associated with multiple grades (e.g., Music), which can impact your analysis. Use Test Grade to analyze test results for a specific grade.',
  [CLASS_SUBJECT]:
    'Filter students based on the subject associated with their classes. Note: This includes all tests taken by those students. Use Test Subject to analyze test results for a specific subject.',
  [CLASS_YEAR]:
    'Filter students by the school year associated with the classes. E.g.: Select 2024-25 to see test results of all classes from that year.',
}
